import styled from "styled-components";

export const StatsContainer = styled.div`
  padding: 120px 10px;
  
  @media (max-width: 600px) {
    padding: 40px 0px;
  }
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 32px;
  justify-items: center;

  @media (max-width: 600px) {
    gap: 24px;
    grid-template-columns: 1fr;
  }
`;
